import React from "react";
import { useZoomNotification } from "../../../../../hooks/home/tabs/dashboard/components/useZoomNotification";

const Announcements = () => {
  const { notifications, loading, error } = useZoomNotification();

  // 날짜 포맷팅 함수 - Timestamp 객체 처리 추가
  const formatDate = (date) => {
    if (!date) return "";

    let dateObj;

    // Firestore Timestamp 객체인 경우 (seconds와 nanoseconds 포함)
    if (date && typeof date === "object" && date.seconds !== undefined) {
      dateObj = new Date(date.seconds * 1000);
    } else if (date && typeof date.toDate === "function") {
      dateObj = date.toDate();
    } else if (date instanceof Date) {
      dateObj = date;
    } else {
      dateObj = new Date(date);
    }

    // 유효한 날짜인지 확인
    if (isNaN(dateObj.getTime())) {
      console.warn("Invalid date:", date);
      return "";
    }

    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    return `${month}. ${day}.`;
  };

  // is_show가 true인 공지사항만 필터링
  const visibleNotifications = notifications.filter(
    (notification) => notification.is_show
  );

  if (loading) {
    return (
      <div className="dashboard-widget-card-harf">
        <div className="dashboard-card-header">
          <h3>공지 사항</h3>
        </div>
        <div>로딩 중...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-widget-card-harf">
        <div className="dashboard-card-header">
          <h3>공지 사항</h3>
        </div>
        <div>공지사항을 불러올 수 없습니다. {error}</div>
      </div>
    );
  }

  return (
    <div className="dashboard-widget-card-harf">
      <div className="dashboard-card-header">
        <h3>공지 사항</h3>
        <button className="dashboard-more-link">더보기 &gt;</button>
      </div>
      <ul className="dashboard-announcement-list">
        {visibleNotifications.slice(0, 4).map((item, index) => (
          <li key={item.id || `announcement-${index}`}>
            <span>{item.title}</span>
            <span className="date">{formatDate(item.created_at)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Announcements;
